import {
  Tooltip,
  Card,
  Typography,
  Input,
  Button,
  Switch,
  Pagination,
  Form,
  Empty,
} from "antd";
import { DeleteOutlined, PlusOutlined, EditOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import ConfirmationModal from "../../Modal/ConfirmationModal";
import { useState, useEffect } from "react";
import SortingArrow from "../../Common/SortingArrow";
import * as Validation from "../../utils/helper/validation";
import * as Apis from "../../utils/helper/enum";
import { changeLoader } from "../../redux/reducers/loader";
import { useDispatch } from "react-redux";
import globalRequest from "../../utils/global/globalRequest";
import toast from "react-hot-toast";
import { paginationLimit, paginationPages } from "../../utils/helper/constants";
import { checkPermissionAction, convertDateString } from "../../utils/helper/utils";
import LatestLocationMap from "../../Modal/LatestLocationMap";
import {
  addDeleteGetLocalStorage,
  storageKeys,
} from "../../utils/global/localData";
import { jwtDecode } from "jwt-decode";
let timer = null;

const ManageDriver = () => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { Search } = Input;
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isLatestLocationMapModalOpen, setIsLatestLocationMapModalOpen] =
    useState(false);
  const [list, setList] = useState([]);
  const [paginationModel, setPaginationModel] = useState(paginationLimit);
  const [inputData, setInputData] = useState({});
  const [totalRows, setTotalRows] = useState(0);
  const [itemData, setItemData] = useState(0);
  const [latestLocationCoordinates, setLatestLocationCoordinates] = useState(
    {}
  );

  const userAccess = addDeleteGetLocalStorage(
    storageKeys?.USER_TOKEN,
    {},
    "get"
  );
  let permissionJson = [];
  if (userAccess) {
    const decoded = jwtDecode(userAccess);
    permissionJson = decoded?.user?.rolePermission?.permissionJson;
  }

  const handleDeleteOk = async () => {
    setIsDeleteModalOpen(false);
    try {
      let value = { status: "deleted" };
      let response = await globalRequest(
        Apis?.MANAGE_DRIVERS?.UPDATE_STATUS + "/" + itemData.id,
        "put",
        value,
        {},
        true
      );
      let apiResponse = response?.data;
      if (response?.status === 200) {
        let msg = "Driver deleted successfully";
        toast.success(msg, {
          duration: 2000,
        });
        getAllDrivers();
      } else {
        toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
  };
  const handleDeleteCancel = () => {
    setIsDeleteModalOpen(false);
  };
  const handleLatestLocationMapOk = async () => {
    setIsLatestLocationMapModalOpen(false);
  };
  const handleLatestLocationMapCancel = () => {
    setIsLatestLocationMapModalOpen(false);
  };
  const handleSort = (column, order) => {
    setInputData((prev) => ({
      ...prev,
      order_by: column,
      order_type: order,
    }));
  };

  const getAllDrivers = async () => {
    dispatch(changeLoader(true));
    try {
      let params = {
        ...inputData,
        page: paginationModel?.page,
        limit: paginationModel?.limit,
      };
      let response = await globalRequest(
        Apis.MANAGE_DRIVERS.GET_ALL_DRIVERS,
        "get",
        {},
        { params: params },
        true
      );
      let apiResponse = response?.data;
      if (response?.status === 200) {
        setList(apiResponse?.data?.data);
        setTotalRows(apiResponse?.data?.paginator?.itemCount);
      } else {
        // toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
    dispatch(changeLoader(false));
  };

  useEffect(() => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      getAllDrivers();
    }, 400);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputData, paginationModel]);

  const handleStatusChange = async (item) => {
    try {
      let value = { status: item.status === "active" ? "inactive" : "active" };
      let response = await globalRequest(
        Apis?.MANAGE_DRIVERS?.UPDATE_STATUS + "/" + item.id,
        "put",
        value,
        {},
        true
      );
      let apiResponse = response?.data;
      if (response?.status === 200) {
        let msg = "Driver active successfully";
        if (item.status === "active") msg = "Driver inactive successfully";
        toast.success(msg, {
          duration: 2000,
        });
        getAllDrivers();
      } else {
        toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
  };
  return (
    <>
      <Card>
        <div className="block sm:flex justify-between	mb-4 gap-5">
          <div className="">
            <Typography className="text-xl font-semibold" align={"left"}>
              Manage Driver
            </Typography>
          </div>
          <div>
            <Search
              placeholder="Search with name and email..."
              onChange={(e) => {
                let value = Validation.strFormat(e.target.value, "trim");
                form.setFieldValue("search", value);
                setInputData((prev) => ({ ...prev, search: value }));
                setPaginationModel((prev) => ({ ...prev, page: 1 }));
              }}
              style={{
                width: window.innerWidth < 768 ? "100%" : 300,
              }}
              className="mx-1.5 cursor-pointer my-3 sm:my-0"
            />
            {checkPermissionAction("Manage Driver", permissionJson, "add") ? (
              <Button
                type="primary"
                size={14}
                icon={<PlusOutlined />}
                className="mx-1.5 cursor-pointer"
                onClick={() => navigate("/add-new-driver")}
              >
                Add New Driver
              </Button>
            ) : null}
          </div>
        </div>
        <div className="relative overflow-x-auto">
          <table className="w-full  text-left	 text-sm  text-gray-500">
            <thead className=" text-gray-700 capitalize text-xs	 bg-gray-50">
              <tr>
                <th scope="col" className="px-3 py-3 whitespace-nowrap">
                  ID{" "}
                  <SortingArrow
                    onSort={(order) => handleSort("id", order)}
                  />
                </th>
                <th scope="col" className="px-3 py-3 whitespace-nowrap">
                  Driver Name{" "}
                  <SortingArrow
                    onSort={(order) => handleSort("firstName", order)}
                  />
                </th>
                <th scope="col" className="px-3 py-3">
                  Email address{" "}
                  <SortingArrow
                    onSort={(order) => handleSort("email", order)}
                  />
                </th>
                <th scope="col" className="px-3 py-3 whitespace-nowrap">
                  Latest Location{" "}
                  <SortingArrow
                    onSort={(order) => handleSort("latestLocation", order)}
                  />
                </th>
                <th scope="col" className="px-3 py-3 whitespace-nowrap">
                  Last Online Date & Time{" "}
                  <SortingArrow
                    onSort={(order) => handleSort("latesdateAndtime", order)}
                  />
                </th>
                <th scope="col" className="px-3 py-3" style={{ width: "180px", minWidth: "180px" }}>
                  Zone{" "}
                  <SortingArrow
                    onSort={(order) => handleSort("zoneName", order)}
                  />
                </th>
                <th scope="col" className="px-3 py-3 whitespace-nowrap">
                  Vehicle type{" "}
                  <SortingArrow
                    onSort={(order) => handleSort("vehicleName", order)}
                  />
                </th>
                <th scope="col" className="px-3 py-3">
                  Status
                </th>
                <th
                  scope="col"
                  className="px-3 py-3 text-center whitespace-nowrap vertical-top"
                >
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {list?.length ? (
                list?.map((item, index) => (
                  <tr className="bg-white border-b">
                    <td
                      className="px-3 py-4 vertical-top font-semibold cursor-pointer"
                      onClick={() => navigate("/view-driver/" + item.id)}
                    >
                      {item?.id}
                    </td>
                    <td
                      className="px-3 py-4 vertical-top font-semibold cursor-pointer"
                      onClick={() => navigate("/view-driver/" + item.id)}
                    >
                      {item?.firstName + " " + item?.lastName}
                    </td>
                    <td className="px-3 py-4 vertical-top">{item?.email}</td>
                    <td
                      className="px-3 py-4 vertical-top cursor-pointer text-[#39b2f3]"
                      onClick={() => {
                        if (!item?.driverDetail?.lastLocationJson) {
                          return false; // Exit if lastLocationJson is not set
                        }
                        setIsLatestLocationMapModalOpen(true);
                        setLatestLocationCoordinates(
                          item?.driverDetail?.lastLocationJson
                        );
                      }}
                    >
                      {item?.driverDetail?.lastLocationJson?.lat}
                      {item?.driverDetail?.lastLocationJson?.lng ? "," : ""}
                      {item?.driverDetail?.lastLocationJson?.lng}
                    </td>
                    <td className="px-3 py-4 vertical-top whitespace-nowrap">
                     {item?.driverDetail?.lastLocationJson?.dateTime
                     ? convertDateString(item.driverDetail.lastLocationJson.dateTime, 
                     'dd/MM/yyyy hh:mm a') : '-'}
                    </td>
                    <td className="px-3 py-4 vertical-top wrap" style={{ width: "180px", minWidth: "180px" }}>
                      {item?.driverDetail?.zoneNames || "-"}
                    </td>
                    <td className="px-3 py-4 vertical-top whitespace-nowrap">
                      {item?.driverDetail?.vehicleType?.name}
                    </td>
                    <td className="px-3 py-4 vertical-top">
                      <Switch
                        checked={item?.status === "active" ? true : false}
                        onChange={() => {
                          handleStatusChange(item);
                        }}
                        disabled={
                          !checkPermissionAction(
                            "Manage Driver",
                            permissionJson,
                            "update_status"
                          )
                        }
                      />
                    </td>
                    <td className="px-3 py-4 text-center whitespace-nowrap vertical-top">
                      <Tooltip title="Edit">
                        <EditOutlined
                          onClick={() => {
                            if (
                              checkPermissionAction(
                                "Manage Driver",
                                permissionJson,
                                "edit"
                              )
                            ) {
                              navigate("/edit-driver/" + item.id);
                            }
                          }}
                          className={`mx-1.5 cursor-pointer ${
                            !checkPermissionAction(
                              "Manage Driver",
                              permissionJson,
                              "edit"
                            )
                              ? "text-gray-400 cursor-not-allowed"
                              : ""
                          }`}
                        />
                      </Tooltip>
                      <Tooltip title="Delete">
                        <DeleteOutlined
                          className={`mx-1.5 cursor-pointer ${
                            !checkPermissionAction(
                              "Manage Driver",
                              permissionJson,
                              "delete"
                            )
                              ? "text-gray-400 cursor-not-allowed"
                              : ""
                          }`}
                          onClick={() => {
                            if (
                              checkPermissionAction(
                                "Manage Driver",
                                permissionJson,
                                "delete"
                              )
                            ) {
                              setIsDeleteModalOpen(true);
                              setItemData(item);
                            }
                          }}
                        />
                      </Tooltip>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={6} className="text-center mt-3">
                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        {list?.length ? (
          <div className="text-right mt-4">
            <Pagination
              defaultCurrent={1}
              total={totalRows}
              pageSizeOptions={paginationPages}
              showSizeChanger={true}
              current={paginationModel?.page}
              pageSize={paginationModel?.limit}
              onChange={(page) =>
                setPaginationModel((prev) => ({ ...prev, page: page }))
              }
              onShowSizeChange={(current, size) =>
                setPaginationModel((prev) => ({ ...prev, limit: size }))
              }
            />
          </div>
        ) : null}
      </Card>
      {/* delete modal */}
      <ConfirmationModal
        ConfirmationHeading="Delete"
        ConfirmationParagraph="Are you sure you want to delete this Driver?"
        isOpen={isDeleteModalOpen}
        onOk={handleDeleteOk}
        onCancel={handleDeleteCancel}
      />
      <LatestLocationMap
        isOpen={isLatestLocationMapModalOpen}
        onOk={handleLatestLocationMapOk}
        onCancel={handleLatestLocationMapCancel}
        latestLocationCoordinates={latestLocationCoordinates}
      />
    </>
  );
};
export default ManageDriver;
